
<template>
    <div>
        <div class="position-relative">
          <section class="section-shaped my-0">
              <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-focus">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
              </div>
              <div class="container shape-container d-flex">
                  <div class="col px-0">
                      <div class="row">
                          <div class="col-lg-7">
                              <h1 class="display-3 text-white"><span>{{ $t('contact.header') }}</span> {{ $t('contact.title1') }} <span></span>
                              </h1>
                              <p class="lead  text-white">{{ $t('contact.para1') }}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
        </div>
        <section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--200">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">{{ $t('contact.title1') }}</h4>
                            <p class="mt-0">{{ $t('contact.para2') }}</p>
                            <form accept-charset="UTF-8" action="https://usebasin.com/f/87407d9533ff" method="POST" ref="form">
                              <base-input
                                class="mt-5"
                                alternative
                                :placeholder="$t('contact.form.firstName')"
                                addon-left-icon="ni ni-user-run"
                                v-model="form.firstName"
                              >
                              </base-input>
                              <base-input
                                alternative
                                :placeholder="$t('contact.form.lastName')"
                                addon-left-icon="ni ni-badge"
                                v-model="form.lastName"
                              >
                              </base-input>
                              <base-input
                                alternative
                                :placeholder="$t('contact.form.companyName')"
                                addon-left-icon="ni ni-shop"
                                v-model="form.companyName"
                              >
                              </base-input>
                              <base-input
                                v-model="form.email"
                                :placeholder="$t('contact.form.email')"
                                addon-left-icon="ni ni-email-83"
                                alternative
                                required
                              >
                              </base-input>
                              <base-input
                                alternative
                                :placeholder="$t('contact.form.subject')"
                                addon-left-icon="ni ni-tag"
                                v-model="form.subject"
                                required
                              >
                              </base-input>
                              <base-input class="mb-4">
                                <textarea
                                  v-model="form.text"
                                  :placeholder="$t('contact.form.body')"
                                  class="form-control form-control-alternative"
                                  name="name"
                                  rows="4"
                                  cols="80"
                                  required
                                >
                                </textarea>
                              </base-input>
                              <base-button v-on:click="submit" type="default" round block size="lg">
                                {{ $t('workshop.form.submit') }}
                              </base-button>
                            </form>
                        </card>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg pt-lg-0">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'/img/tiles/scrum.png'" class="card-img-top" alt="Two men using computers">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">{{ $t('tile') }}</h4>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <h3>{{ $t('contact.title2') }}</h3>
                            <p class="lead">{{ $t('contact.para3') }}</p>
                            <p>Nieuwerhoek 38</p>
                            <p>3813 RS Amersfoort</p>
                            <p>{{ $t('contact.country') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "contact",
  components: {},
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        subject: '',
        body: ''
      }
    }
  },
  methods: {
    submit: function() {
      this.$refs.form.submit();
    }
  }
};
</script>

<i18n>
{
  "en": {
    "tile": "WeSaidSo Software Engineering"
  },
  "nl": {
    "tile": "WeSaidSo Software Engineering"
  }
}
</i18n>
